const DefaultReviews = [
  {
    excerpt:
      "Atlantic Bay made it possible for me to become a homeowner. I loved working with them and I’d recommend them above anyone else.",
    review:
      "Atlantic Bay made it possible for me to become a homeowner. I loved working with them and I’d recommend them above anyone else.",
    reviewer: "Dawn Z.",
    source: "Google",
  },
  {
    excerpt:
      "Atlantic Bay Mortgage group made my first-time home buying process a breeze! They offer competitive rates and kept me informed throughout my home buying process.",
    review:
      "Atlantic Bay Mortgage group made my first-time home buying process a breeze! They offer competitive rates and kept me informed throughout my home buying process.",
    reviewer: "Robert L.",
    source: "Zillow",
  },
  {
    excerpt:
      "The refinance process was extremely quick, easy, and affordable. I enjoyed being able to upload documents and see my loan progress through their online management software. Thank you!",
    review:
      "The refinance process was extremely quick, easy, and affordable. I enjoyed being able to upload documents and see my loan progress through their online management software. Thank you!",
    reviewer: "Matthew F.",
    source: "Recent Homebuyer",
  },
  {
    excerpt:
      "I have done multiple loans with Atlantic Bay. Always great service!",
    review:
      "I have done multiple loans with Atlantic Bay. Always great service!",
    reviewer: "Kristin D.",
    source: "Recent Homebuyer",
  },
  {
    excerpt:
      "The Atlantic Bay team was awesome to work with. They did my closing in record time and were very diligent and thorough throughout the process.",
    review:
      "The Atlantic Bay team was awesome to work with. They did my closing in record time and were very diligent and thorough throughout the process.",
    reviewer: "Ryan W.",
    source: "Recent Homebuyer",
  },
  {
    excerpt:
      "Absolutely awesome experience. Great communication from the entire team. Even being across the country and having to conduct all of our business remotely, the process was remarkably smooth. Thank you!",
    review:
      "Absolutely awesome experience. Great communication from the entire team. Even being across the country and having to conduct all of our business remotely, the process was remarkably smooth. Thank you!",
    reviewer: "Richard R.",
    source: "Recent Homebuyer",
  },
  {
    excerpt:
      "Atlantic Bay is amazing! They really help you understand the mortgage process and answer any questions you have! I highly recommend them for their professionalism and integrity!",
    review:
      "Atlantic Bay is amazing! They really help you understand the mortgage process and answer any questions you have! I highly recommend them for their professionalism and integrity!",
    reviewer: "Casey L.",
    source: "Google",
  },
  {
    excerpt:
      "Couldn't not be happier with Atlantic Bay. They treated us like family and took care of every question we had during this process. They made our experience extremely easy and stress-free!",
    review:
      "Couldn't not be happier with Atlantic Bay. They treated us like family and took care of every question we had during this process. They made our experience extremely easy and stress-free!",
    reviewer: "Andrew B.",
    source: "Zillow",
  },
]

module.exports = DefaultReviews
